var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.clickIcon}},[_c('svg',{staticClass:"icon-type-folder"},[_c('use',_vm._b({},'use',{'href':'#icon-list-selected_' + _vm.nameIcon+'-icon'},false))])])}
var staticRenderFns = []

export { render, staticRenderFns }